import React, { useEffect, useRef, useMemo, useCallback, useState } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash-es';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import { useIntl, history, getLocale } from 'umi';
import { ECHARTSCOLOR, FIRST_COLORS } from '@/pages/intelligence/utils/echartsConst';
// import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';

import ChartHooks from './chartHook';
import Loading from '@/pages/intelligence/components/Loading';
import { ratioValueFormat, financeFormat } from '@/pages/home/utils/common';
import { datamapIntelligenceMetricsPath } from '@/pages/intelligence/utils/common';
import { fireWindowResize } from '@intelligence/v3/utils/bom';
import './index.scss';
interface Iprops {
  gameId: string;
  entityType: string;
  kpiPlayerData: any;
  playersByCountry: any;
  steamLoading: boolean;
  showNoDataMetricCard?: boolean;
  setSteamDataHasEmptyLineData?: React.Dispatch<React.SetStateAction<boolean>>;
}
const COLORLIST = [...ECHARTSCOLOR, ...FIRST_COLORS];
const CHART_BAR = 'bar';
const IS_NODATA = false;
const DEFAULT_BAR_HEIGHT = 130;

const calcIsEmptyTimeSpentPlayingCard = (data?: {
  avg_play_time?: number | null;
  median_play_time?: number | null;
}): boolean => {
  return !data?.avg_play_time && !data?.median_play_time;
};

const calcIsEmptyPlayersByCountryCard = (list?: any[]): boolean => {
  if (isEmpty(list)) return true;
  return list!.every((item) => {
    const itemValue = Number.parseFloat(item?.percentage as any);
    return Number.isNaN(itemValue);
  });
};

const CommonChart = (props: Iprops) => {
  const { gameId = '', entityType, kpiPlayerData = {}, playersByCountry = [], steamLoading, showNoDataMetricCard, setSteamDataHasEmptyLineData } = props;

  const isEmptyTimeSpentPlayingCard = calcIsEmptyTimeSpentPlayingCard(kpiPlayerData);
  const isEmptyPlayersByCountryCard = calcIsEmptyPlayersByCountryCard(playersByCountry);
  const isEmptyCards = isEmptyTimeSpentPlayingCard && isEmptyPlayersByCountryCard;

  const chartType = CHART_BAR;
  const isNodata = IS_NODATA;
  const GRID_CONFIG = {
    height: DEFAULT_BAR_HEIGHT,
    left: 40,
    right: 15,
    top: 30,
  };
  const { formatMessage } = useIntl(); // 中英切换方法
  const cardRef = useRef(null);
  const countiesRef = useRef(null);
  const barNameList = useMemo(() => playersByCountry.map((item: any) => item.country_name), [playersByCountry]);
  const steamData = useMemo(
    () =>
      playersByCountry.map((item: any, i: number): any => ({
        type: CHART_BAR,
        name: item.country_name,
        value: item.percentage,
        itemStyle: {
          color: COLORLIST[i],
        },
        label: {
          show: true,
          position: 'top',
          color: '#444',
          distance: 4,
          fontSize: 12,
          formatter: (params: any) => `${item.percentage}%`,
        },
      })),
    [playersByCountry],
  );
  const toolTopFormateFunction = useCallback(
    (params: any[]) => {
      const param = params[0];
      return `<div class='dbi-tooltips-content'>
        <div class='dbi-tooltips-title'>
          <div class='dbi-tooltips-left-title'>${formatMessage({
            id: 'dbi_top_kpiOverview_players_by_country',
          })}</div>
          <div class='dbi-tooltips-right-title'>Rate</div>
        </div>
         <div class='dbi-tooltips-context'>
          <div class='dbi-tooltips-dot' style="background-color:${param.color}"></div>
          <div class='dbi-tooltips-desc'>${param.name}</div>
          <div class='dbi-tooltips-value'>${ratioValueFormat(param.value, 2, false, '', true, 3)}</div>
        </div>
      </div>`;
    },
    [formatMessage],
  );

  const yAxisFormatterFunction = useCallback(
    (formatValue: any) => ratioValueFormat(formatValue, 2, false, '', true, 3),
    [],
  );
  const defaultBarSetting = {
    topChartsType: 'pc-console-kpioverview',
    chartType,
    ifNoBarImg: true,
    ifNeedSourceImg: false,
    xAxisBarConfig: {
      axisLabel: {
        color: '#838697',
        formatter: (val: string) => val,
        margin: 12,
      },
      animationSetting: {
        animationDuration: 100,
        animationEasingUpdate: 'linear',
      },
    },
    yAxisFormatter: yAxisFormatterFunction,
    tooltipFormatter: toolTopFormateFunction,
  };
  // steam拥有的游戏可视化
  const countiesOptions = useBarCharts({
    seriesData: steamData,
    barOrPieData: steamData,
    barNameList,
    ...defaultBarSetting,
  }).barOption;
  // const initResize = () => {
  //   const barIntance = hoursRef.current?.getBarInstance();
  //   const countiesIntance = countiesRef.current?.getBarInstance();
  //   if (!barIntance) return;
  //   setTimeout(() => {
  //     barIntance.resize();
  //     countiesIntance.resize();
  //   }, 1);
  //   const listenWidth = window.innerWidth;
  //   setRotate(listenWidth < MIN_SHOW_WIDTH);
  // };
  // const handleResize = useThrottleFn(initResize, { wait: 500 }).run;
  // useEffect(() => {
  //   window.addEventListener('resize', handleResize, true);
  //   return () => {
  //     window.removeEventListener('resize', () => {});
  //   };
  // }, []);
  // const setHoursChart = (refs: any) => {
  //   if (refs.current) {
  //     const barIntance = refs.current?.getBarInstance();
  //     barIntance.setOption({
  //       xAxis: {
  //         axisLabel: {
  //           rotate: rotate ? ROTATE_ANGLE : 0,
  //         },
  //       },
  //       grid: {
  //         height: rotate ? ROTATE_BAR_HEIGHT : DEFAULT_BAR_HEIGHT,
  //       },
  //     });
  //   }
  // };
  // useEffect(() => {
  //   setHoursChart(hoursRef);
  //   setHoursChart(countiesRef);
  // }, [rotate]);
  const pushBarWidth = function (opt: any, barWidth: number) {
    opt?.series.forEach((element: any) => {
      element.barWidth = barWidth;
    });
    return {
      ...opt,
    };
  };
  const handleClickLearnMore = (dataSource: string) => {
    history.push({
      pathname: datamapIntelligenceMetricsPath,
      query: {
        pageid: dataSource,
        gameType: entityType || '',
      },
    });
  };

  const getOverviewCountry = () => {
    history.push(`/intelligence/topCharts/pcConsoleGames/gamesDetails/${gameId}/countries/players_by_country`);
  };

  const showTimeSpentPlayingCard = showNoDataMetricCard || !isEmptyTimeSpentPlayingCard;
  const showPlayersByCountryCard = showNoDataMetricCard || !isEmptyPlayersByCountryCard;
  const showSplitter = showTimeSpentPlayingCard && showPlayersByCountryCard;

  useEffect(() => {
    if (steamLoading) return;
    setSteamDataHasEmptyLineData?.(isEmptyTimeSpentPlayingCard || isEmptyPlayersByCountryCard);
  }, [steamLoading, isEmptyTimeSpentPlayingCard, isEmptyPlayersByCountryCard]);

  useEffect(() => {
    fireWindowResize();
  }, [showNoDataMetricCard]);

  if (isEmptyCards) return null;
  return (
    <>
      <div className="dbi-common-chart-box" ref={cardRef}>
        {/* <div className={`dbi-common-chart-item ${isEmptyStatus ? 'dbi-kv-small-height' : ''}`}> */}
        {/*   <div className="dbi-common-chart-subTitle"> */}
        {/*     {formatMessage({ id: 'dbi_top_kpiOverview_timeSpentPlaying' })} */}
        {/*     <TipContext */}
        {/*       AWidth={400} */}
        {/*       placement="top" */}
        {/*       className="dbi-common-chart-info-icon" */}
        {/*       tipText={ */}
        {/*         <> */}
        {/*           <div>{formatMessage({ id: 'dbi_top_kpiOverview_timeSpentPlaying_info' })}</div> */}
        {/*           <div> */}
        {/*             {formatMessage({ id: 'dbi_top_kpiOverview_timeSpentPlaying_info_come' })} */}
        {/*             <span */}
        {/*               className="dbi-common-chart-link" */}
        {/*               onClick={() => handleClickLearnMore('databrain')} */}
        {/*             > */}
        {/*               {formatMessage({ id: 'dbi_top_learn_more' })} */}
        {/*             </span> */}
        {/*           </div> */}
        {/*         </> */}
        {/*       } */}
        {/*     /> */}
        {/*   </div> */}
        {/*   /!* eslint-disable-next-line no-nested-ternary *!/ */}
        {/*   {chartLoading ? ( */}
        {/*     <div className="dbi-common-chart-empty-dom"> */}
        {/*       <Loading content={formatMessage({ id: 'common_loading' })} /> */}
        {/*     </div> */}
        {/*   ) : isEmptyStatus ? ( */}
        {/*     <NoData /> */}
        {/*   ) : ( */}
        {/*     <ChartsIndex */}
        {/*       ref={hoursRef} */}
        {/*       chartLoading={chartLoading} */}
        {/*       barOption={pushBarWidth({ ...barOption, grid: GRID_CONFIG }, 30)} */}
        {/*       chartType={chartType} */}
        {/*       isNodata={isNodata} */}
        {/*     /> */}
        {/*   )} */}
        {/* </div> */}

        {showTimeSpentPlayingCard && (
          <div className={'dbi-common-steam-data-left dbi-common-chart-item'}>
            <div className="dbi-common-chart-subTitle">
              {formatMessage({id: 'dbi_top_kpiOverview_timeSpentPlaying'})}
            </div>
            <div className={'dbi-common-chart-left-sub-title'}>
              <div className={'dbi-common-chart-left-sub-title-gray-title'}>
                {formatMessage({id: 'dbi_top_kpiOverview_avg_play_time'})}
              </div>
              <div className={'dbi-common-chart-left-sub-title-bold-title'}>
                {kpiPlayerData?.avg_play_time ? financeFormat(kpiPlayerData?.avg_play_time, 2, false, '-') : '-'}
              </div>
            </div>
            <div className={'dbi-common-chart-left-sub-title'}>
              <div className={'dbi-common-chart-left-sub-title-gray-title'}>
                {formatMessage({id: 'dbi_top_kpiOverview_median_play_time'})}
              </div>
              <div className={'dbi-common-chart-left-sub-title-bold-title'}>
                {kpiPlayerData?.median_play_time ? financeFormat(kpiPlayerData?.median_play_time, 2, false, '-') : '-'}
              </div>
            </div>
          </div>
        )}
        <div className={classnames('dbi-common-chart-white-box', { 'dbi-common-chart-white-box--show': showSplitter })}></div>
        {showPlayersByCountryCard && (
          <div className="dbi-common-chart-item" style={{cursor: 'pointer'}} onClick={getOverviewCountry}>
            <div className="dbi-common-chart-subTitle">
              {formatMessage({id: 'dbi_top_kpiOverview_players_by_country'})}
            </div>
            <ChartsIndex
              ref={countiesRef}
              chartLoading={steamLoading}
              barOption={pushBarWidth({...countiesOptions, grid: GRID_CONFIG}, 46)}
              chartType={chartType}
              isNodata={isNodata}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default CommonChart;
